import Dexie from "dexie";

const db: any = new Dexie("rpformsweb");

const dbVersion: any = db.version(4).stores({
    snapshots: "++id,[form_id+entity_id+customer_id], created",
});

export default db;
